
(function (global) {
    if (global.Notyf) {
      global.Notyf.Notyf = global.Notyf;
    }
}(this));
